import {Hub, youGileUserId} from 'yougile-model'
import {State} from '../../types'

export const sendOtherValues = (
  state: State,
  task: Hub,
  row: Record<string, string>
): void => {
  let text = ''
  const rowKeys = Object.keys(row)
  for (let index = 0; index < rowKeys.length; index++) {
    const key = rowKeys[index]
    if (state.processedColumns.includes(key)) {
      continue
    }

    const theLastLine = index === rowKeys.length - 1
    text += `${key}: ${row[key]}${!theLastLine ? '\n' : ''}`
  }

  if (text === '') {
    return
  }

  task.chat.addMessage(youGileUserId, {text})
}
